export const DVZA_SUPPORT_CONSOLE_SEARCH_SCOPE = 'dvza-support-console-search';
export const DVZA_SUPPORT_CONSOLE_REPORTS_SCOPE = 'dvza-support-console-reports';